/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FunctionComponent } from 'react'
import styled from 'styled-components/native'

import { Button } from 'ui/designSystem/Button/Button'
import { CloseFilled } from 'ui/svg/icons/CloseFilled'

type ModalSimpleHeaderProps = {
  onClose: () => void
}

export const ModalSimpleHeader: FunctionComponent<ModalSimpleHeaderProps> = ({ onClose }) => {
  return (
    <HeaderContainer>
      <Button
        icon={CloseFilled}
        iconButton
        accessibilityLabel="Fermer la fenêtre"
        variant="tertiary"
        color="neutral"
        onPress={onClose}
      />
    </HeaderContainer>
  )
}

const HeaderContainer = styled.View(({ theme }) => ({
  flexShrink: 0,
  flexDirection: 'row',
  justifyContent: 'flex-end',
  paddingHorizontal: theme.designSystem.size.spacing.xxl,
  paddingTop: theme.designSystem.size.spacing.xxl,
  paddingBottom: theme.designSystem.size.spacing.l,
}))
